import React from 'react';
import styled from 'styled-components';

import MonthSelector from '../organisms/MonthSelector';
import { TotalsByMonthPanelContainer as TotalsByMonth } from '../organisms/TotalsByMonth';
import { CashflowRowContainer } from '../organisms/CashflowRow';

export function SpendingSummary(): React.ReactElement {
  return (
    <Wrapper>
      <TotalsByMonth area="totals" />
      <MonthSelector area="month" />
      <CashflowRowContainer />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 128px;
`;
